export default __webpack_public_path__ + "app/assets/images/common/icon_i-fcad6ca41c306c714f34346321bdd80d.png";